import { create } from "zustand";
export const useStore = create((set) => ({
    language: null,
    cart: [],
    customerName: "",
    orderId: null,
    paymentStatus: "idle",
    setLanguage: (l) => set({ language: l }),
    addToCart: (p, qty = 1) => set((s) => {
        const existing = s.cart.find((c) => c.sku === p.sku);
        if (existing) {
            return { cart: s.cart.map((c) => (c.sku === p.sku ? { ...c, qty: c.qty + qty } : c)) };
        }
        return { cart: [...s.cart, { sku: p.sku, qty, product: p }] };
    }),
    setQty: (sku, qty) => set((s) => ({
        cart: qty <= 0
            ? s.cart.filter((c) => c.sku !== sku)
            : s.cart.map((c) => (c.sku === sku ? { ...c, qty } : c)),
    })),
    removeFromCart: (sku) => set((s) => ({ cart: s.cart.filter((c) => c.sku !== sku) })),
    clearCart: () => set({ cart: [] }),
    setName: (n) => set({ customerName: n }),
    setOrderId: (id) => set({ orderId: id }),
    setPaymentStatus: (s) => set({ paymentStatus: s }),
    reset: () => set({ language: null, cart: [], customerName: "", orderId: null, paymentStatus: "idle" }),
}));
export const cartTotal = (cart) => cart.reduce((s, i) => s + i.qty * i.product.price, 0);
